import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-sm">
        <p className="text-caption font-semibold text-ink-muted">404</p>
        <h1 className="mt-2 text-display text-ink">Page not found</h1>
        <p className="mt-2 text-body text-ink-muted">This address does not match a page in MerchantView.</p>
        <Link to="/" className="btn-primary mt-6">
          Go to MerchantView
        </Link>
      </div>
    </main>
  );
}
